module.exports = __webpack_public_path__ + "media/svg/symbols-5776d50e.svg";